<template>
  <div class="clock-title">
    <div>
      {{ time }}
    </div>
    <!--  <div style="font-size:14px;font-weight: normal;">数据更新至：{{ updateTime }}</div>-->
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
import { getTrademarkUpdateTim } from "../api/dataView";

export default {
  name: "clock",
  data() {
    return {
      time: "",
      timer: null,
      updateTime: "",
    };
  },
  methods: {
    // async getTrademarkUpdateTim() {
    //   let res = await getTrademarkUpdateTim();
    //   if (res.data.data) {
    //     this.updateTime =res.data.data.time
    //   }
    // },
  },
  mounted() {
    this.timer = setInterval(()=>{
      this.time = moment().format('HH : mm : ss')
    },1000)
    // this.getTrademarkUpdateTim()
  },
  destroyed() {
    this.timer = null
  }
};
</script>

<style scoped>
.clock-title {
  /* opacity: 0.5; */
  width: auto;
  height: auto;
  font-size: 48px;
  font-family: Liquid Crystal-Bold, Liquid Crystal;
  font-weight: bold;
  color: #18F8FF;
}
</style>